import { Container } from "@/components/ui/container";
import Title from "@/components/ui/title";
import S from "./index.module.scss";
import { DNA } from "../../constants/dna";
import DnaCard from "./dna-card";
import Image from "next/image";
import { IMPACT } from "../../constants/impact";
import ImpactCard from "./impact-card";
import { useTranslations } from "next-intl";

const Dna = () => {
  const t = useTranslations("about.dna");

  return (
    <div className={S.wrapper}>
      <Container>
        <Title variant={"black"}>{t("title")}</Title>
      </Container>
      <div>
        <div className={S.borderWrap}>
          <Image className={S.image} alt="dna" src="/images/about/dna/dna.png" height={340} width={1340} />
          <div className={S.grid}>
            {DNA.map(item => (
              <DnaCard item={item} key={item} />
            ))}
          </div>
        </div>
        <div className={S.grid}>
          {IMPACT.map(item => (
            <ImpactCard item={item} key={item.title} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dna;
